var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgAddress = function SvgAddress(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.499983,0 C27.7165857,0 10,17.3022006 10,38.5687889 C10,46.4639677 12.4318229,54.0634974 16.9794692,60.4569125 C17.2061645,60.8399126 17.4362947,61.2094742 17.7076422,61.5689569 L46.5391699,98.6796571 C47.3222993,99.5296486 48.3733414,100 49.499983,100 C50.6128168,100 51.6707285,99.5262893 52.5878142,98.5217536 L81.2853856,61.5655971 C81.5670375,61.1960356 81.8109067,60.7928776 81.9414282,60.557702 C86.5461653,54.1105701 89.010557,46.4333671 89,38.5687889 C89,17.3022006 71.2798769,0 49.499983,0 Z M49.501765,54 C41.5039092,53.9960718 35.0175126,47.4279695 35,39.3155638 C35.2123184,31.3474914 41.6415885,25 49.5,25 C57.3584115,25 63.7876815,31.3474914 64,39.3155638 C63.9805493,47.425174 57.4968682,53.9905238 49.501765,53.9964193 L49.501765,54 Z"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgAddress);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "address.3e0b8076f4f40a4e0432aa957cb68334.svg";